module.exports = __webpack_public_path__ + "static/favicon-33689de06b149cd491a0bacf26474fed.png";